import {
  DealItem,
  DealItemWithVersions,
} from '@/lib/graphql/generated/graphql';

export function getAllFieldValues(
  products: DealItemWithVersions[],
  field: keyof DealItem
): number[] {
  return products.map((product) => {
    const value = product.activeVersion[field];
    if (value === null || value === undefined) return 0;
    const numValue = typeof value === 'number' ? value : Number(value);
    return isNaN(numValue) ? 0 : numValue;
  });
}
